import React from "react";

const facts = [
    { label: "Name", value: "United Arab Emirates" },
    { label: "Location", value: "Middle East" },
    { label: "Time", value: "IST (-) 1 ½ hours" },
    { label: "Major cities", value: "Dubai, Abu Dhabi, Sharjah, Al Ain, Fujairah." },
    { label: "Language", value: "Arabic (official), Persian, English, Hindi, Urdu" },
    { label: "Area", value: "77,700 sq kms" },
    { label: "National day", value: "02-Dec" },
    { label: "Main Airline", value: "Emirates (EK) | Gulf Air (GF)" },
    { label: "International Airports", value: "Dubai (DXB) | Abu Dhabi (AUH) | Fujairah (FJR)" },
    { label: "Best time to visit Dubai", value: "November to March" },
];

export function DubaiFacts() {
    return (
        <div>
            <div className="mb-6">
                <h2 className="text-3xl font-bold">Dubai Facts and Figures</h2>
            </div>
            <div className="space-y-4">
                {facts.map((fact) => (
                    <div key={fact.label} className="grid grid-cols-1 md:grid-cols-3 gap-2">
                        <p className="font-semibold text-neutral-800 md:col-span-1">{fact.label}:</p>
                        <p className="text-neutral-600 md:col-span-2">{fact.value}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
